import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import React, { useEffect, useState } from "react"
import { Button, Grid, Typography } from "@mui/material"
import { gridSizeMdLg12 } from "@/shared"
import { useCreateRegistroBitacoraSoftnet, useFetchBitacoraSoftnet } from "@/shared/actions/erp/operaciones/softnet-seguimientoactividades/soft-seguimientoactividades.actions";

import { CustomTextAreaNoForm } from "@/shared/components/ui"
import { toast } from "react-toastify"
import { BitacoraSoftnet } from "@/shared/actions/erp/operaciones/softnet-seguimientoactividades";
import dayjs from "dayjs";

type Props = {
    data: any
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const ModalSendToBitacora = ({
    data,
    open,
    setOpen
}: Props) => {

    const [comentario_bitacora, setComentarioBitacora] = useState<string>("")
    const [bitacoraSoftnet, setBitacoraSoftnet] = useState<BitacoraSoftnet[]>([])
    
    const {
        mutateAsync: createRegistroBitacoraSoftnet,
    } = useCreateRegistroBitacoraSoftnet();
    const {
        mutateAsync: mutateBitacoraSoftnet,
    } = useFetchBitacoraSoftnet({});

    useEffect(()=>{
        if(!data && open){
            toast.error("El registro no cuenta con tipo de actividad")
            return;
        }
        if(open && data){
            mutateBitacoraSoftnet({
                id: data?.id,
                tipo: data?.tipo_actividad=="instalacion" ? 1
                : data?.tipo_actividad=="migracion" ? 2
                : data?.tipo_actividad=="traslado" || data?.tipo_actividad=="visitas" ? 3
                : 0,
            })?.then((bitacoraSoftnet) => {
                setBitacoraSoftnet(bitacoraSoftnet?.data as BitacoraSoftnet[])
            })
        }
    },[open])


    return (
    <ScrollableDialogProps
        open={open}
        title="Enviar a Bitácora"
        minWidth="40%"
        onClose={() => {
            setComentarioBitacora("")
            setOpen(false)
        }}

        showConfirmBtn={false}
        cancelTextBtn="Cerrar"
        confirmTextBtn="Enviar"
        contentNode={<Grid container item {...gridSizeMdLg12} spacing={2} p={2}>
            <Grid container item {...gridSizeMdLg12} spacing={2} p={2}>
                <Typography>
                Escriba un comentario para la actividad de <b>{data?.tipo_actividad}</b> del técnico <b>{data?.nombre_tecnico}</b> con respecto al cliente <b>{data?.nombre_cliente}</b>
                </Typography>
            </Grid>
            <Grid item {...gridSizeMdLg12} spacing={2} p={2}>
                <CustomTextAreaNoForm
                    label="Escriba el comentario"
                    value={comentario_bitacora}
                    onChangeValue={(value) => setComentarioBitacora(value)}
                    size={gridSizeMdLg12}
                />
                <Button
                    sx={{
                        mt: 2
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        if(!comentario_bitacora){
                            toast.error("Debe escribir un comentario")
                            return;
                        }
                        createRegistroBitacoraSoftnet({
                            id_instalacion: data?.id,//data?.id,148398
                            tipo_instalacion: data?.tipo_actividad=="instalacion" ? 1
                            : data?.tipo_actividad=="migracion" ? 2
                            : data?.tipo_actividad=="traslado" || data?.tipo_actividad=="visitas" ? 3
                            : 0,
                            comentario: comentario_bitacora||"N/A",
                        })
                        setComentarioBitacora("")
                        setOpen(false)
                    }}
                    fullWidth
                >
                    Enviar
                </Button>
            </Grid>
            <Grid container item {...gridSizeMdLg12} spacing={2} p={2}>
                <Typography variant="h6">Bitácora</Typography>
            </Grid>
            <Grid container item {...gridSizeMdLg12} spacing={2} p={2}>
                {
                    bitacoraSoftnet?.map((item: BitacoraSoftnet, key: number) => (
                        <Grid key={`bitacora-${key}`} item 
                        {...gridSizeMdLg12} spacing={2} p={2}
                        sx={{
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            p: 1,
                            mb: 1
                        }}
                        >
                            <Typography fontWeight={"bold"}>{item?.nombre_empleado}</Typography>
                            <Typography sx={{
                                pt: 1
                            }}>{item?.acuerdo}</Typography>
                            <Grid container item {...gridSizeMdLg12} spacing={2} p={2}
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}>
                                <Typography>{ dayjs(`${item?.fecha_llamada}T${item?.hora_llamada}`).format("DD/MM/YYYY HH:mm:ss")}</Typography>
                            </Grid>
                        </Grid>
                    ))
                }
            </Grid>
        </Grid>}
    />
  )
}


export default ModalSendToBitacora